export default function CoffeeMaker() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_845_6374)">
                <path
                    d="M19.5 40.5V8.83333C19.5 8.09695 18.903 7.5 18.1667 7.5C12.2756 7.5 7.5 12.2756 7.5 18.1667V38.25C7.5 39.4926 8.50736 40.5 9.75 40.5H19.5Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M40.5 31.125C41.1213 31.125 41.625 30.6213 41.625 30C41.625 29.3787 41.1213 28.875 40.5 28.875V31.125ZM36 31.125H40.5V28.875H36V31.125Z"
                    fill="#949494"
                />
                <path
                    d="M36 16.5L36 15C36 11.6863 33.3137 9 30 9L19.5 9L19.5 16.5L36 16.5Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M33 21L33 16.5L27 16.5L27 21L33 21Z" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M36 30.75L36 28.5L25.5 28.5L25.5 30.75C25.5 33.6495 27.8505 36 30.75 36C33.6495 36 36 33.6495 36 30.75Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.5 40.5L39.6 40.5C40.0971 40.5 40.5 40.0971 40.5 39.6C40.5 37.6118 38.8882 36 36.9 36L19.5 36L19.5 40.5Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_845_6374">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
